import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import CustomImage from '../Utils/CustomImage'
import WhatsIncludedPanel from '../WhatsIncludedPanel'
import TestimonialsPanel from '../TestimonialsPanel'
import WhyDoWeChargeAFee from '../WhyDoWeChargeAFee'
import { gaEvents } from '../../analytics/events'
import { withRouter } from 'react-router-dom'
import { withAuth } from '../AuthContext'
import { getCurrencySign } from '../../utils/utils'
import { shouldTranslateTo } from '../../utils/utils'
import {
  Title,
  Subtitle,
  ActionButtons,
  LoadingButton,
} from '../Utils/CustomClasses'
import { scrollIntoView } from '../Hooks/ScrollView'

const ContainerBox = styled.div`
  padding: 30px 36px 55px 36px;
  background-color: #ffffff;

  @media (max-width: 767px) {
    padding: 25px 25px 25px 25px;
  }
`

const Center = styled.div`
  text-align: center;
  margin-top: 40px;
`

const CenterSmallMargin = styled(Center)`
  margin-top: 0;
`

const PriceChoiceBox = styled.div`
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 5px 9px -2px #b5b5b5;
  border: 1px solid #eee;
  padding: 26px 26px 30px;
  margin: 40px 0 0;
  width: 100%;
`

const PriceChoiceTitle = styled(Title)`
  font-weight: 600;
`

const PriceChoiceSubtitle = styled(Subtitle)`
  font-family: 'Open Sans', sans-serif;
  font-weight: 200;
  font-size: 16px;
  margin: 24px 20px 30px 20px;

  @media (max-width: 799px) {
    font-size: 18px !important;
  }
`

const FlexRowPrice = styled.div`
  display: flex;
  flex-direction: row;
  gap: 30px;
  align-items: flex-end;
  justify-content: flex-end;
  margin-top: 60px;

  & > div {
    flex-basis: 50%;
  }

  @media (max-width: 799px) {
    flex-direction: column;
    margin-top: 20px;

    & > div {
      width: -webkit-fill-available;
    }
  }
`

const PriceBox = styled.div`
  box-shadow: ${(props) => (props.shadow ? '0 5px 9px -2px #b5b5b5;' : 'none')};
  border: 1px solid #a5a5a5;
  border-radius: 10px;
  overflow: hidden;
  min-height: 300px;
`

const PriceBoxHeader = styled.div`
  background-color: #4350b0;
  padding: 6px;
`

const PriceBoxHeaderBadgeContainer = styled.div`
  position: relative;
`

const PriceBoxHeaderBadge = styled.div`
  background-color: #9b0000;
  border-radius: 50%;
  box-shadow: 4px 4px 5px -2px #b5b5b5;
  height: 70px;
  width: 70px;
  position: absolute;
  top: -16px;
  right: -10px;
`

const PriceHeaderSubtitle = styled(Subtitle)`
  color: #fff;
  font-family: 'Open Sans', sans-serif;
  font-weight: 200;
`

const PriceHeaderBadgeSubtitle = styled(PriceHeaderSubtitle)`
  color: #fff;
  font-family: 'Open Sans', sans-serif;
  font-size: 13px;
  font-weight: 400;
  line-height: 126%;
  margin: 16px 0 0;
`

const PriceBoxPrice = styled.div`
  border-bottom: 1px solid #a5a5a5;
  align-items: center;
  justify-content: center;
`

const PriceContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  margin: 30px auto 34px;
  width: 170px;
`

const PriceSubtitle = styled(Subtitle)`
  color: #000;
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  letter-spacing: -1px;
  margin: 0 16px 0 0;

  @media (max-width: 799px) {
    font-size: 50px !important;
  }
`

const CurrencySubtitle = styled(Subtitle)`
  font-family: 'Open Sans', sans-serif;
  font-size: 23px;
  font-weight: 400;
  margin: -36px 4px 0 0;
`

const PriceDurationSubtitle = styled(Subtitle)`
  font-family: 'Open Sans', sans-serif;
  color: #6a6a6a;
  font-weight: 600;
  letter-spacing: 0px;
  margin: 0 0 0 2px;

  @media (max-width: 799px) {
    font-size: 14px !important;
  }
`

const PriceBoxInfo = styled.div`
  padding: 20px;
  align-items: center;
  justify-content: center;
`

const PriceInfoSubtitle = styled(Subtitle)`
  color: #5a5a5a;
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  letter-spacing: 0px;
  margin: 0 auto 30px auto;
  width: 172px;
  min-height: 81px;

  b {
    color: #06944d;
    font-weight: 700;
  }

  @media (max-width: 799px) {
    font-size: 21px !important;
    width: 270px;
  }

  @media (max-width: 499px) {
    font-size: 18px !important;
    width: 210px;
  }

  @media (min-width: 1100px) {
    font-size: 20px !important;
  }
`

const ChoiceButton = styled(ActionButtons)`
  background-color: #0bac5d;
  width: -webkit-fill-available;
`

const ChoiceLoadingButton = styled(LoadingButton)`
  background-color: #0bac5d;
  width: -webkit-fill-available;
  padding: 10px 30px;
`

const WhatsIncludedWrapper = styled.div`
  margin: 60px 0 0 0;
`

const TestimonialsWrapper = styled.div`
  margin: 60px 0 0 0;
`

const ChooseSubscription = ({ data, onUpdate, actionRef }) => {
  const [currencySign, setCurrencySign] = useState('')
  const [pageText, setPageText] = useState([])
  const [pageText2, setPageText2] = useState([])
  const [loading, setLoading] = useState('')

  useEffect(() => {
    setTimeout(function () {
      //scrollIntoView(actionRef)
    }, 1000)
  }, [])

  useEffect(() => {
    gaEvents.eventGeneric(
      'page_load',
      'choose-membership-fee-page-loaded',
      data.auth.user.id + ' - choose membership fee - page loaded'
    )

    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          pageValue === 'profile-pay'
            ? setPageText(pageText)
            : setPageText2(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    const getCurrency = async () => {
      const currencySignData = await getCurrencySign(
        data.auth.user.currencyValue
      )
      setCurrencySign(currencySignData.sign)
    }
    getCurrency()

    getPageText('profile-pay', language)
    getPageText('homepage-v2', language)
  }, [])

  const handleSetPriceButton = (e, fee, option) => {
    e.preventDefault()
    setLoading(option)

    gaEvents.eventGeneric(
      'button_click',
      'subscription-choice-button-clicked',
      data.auth.user.id +
        ' - choose membership fee - ' +
        fee +
        ' - drop down menu - price chosen' +
        option +
        ' - drop down menu - option chosen'
    )

    const userData = {
      membershipFee: fee,
      subscriptionType: option,
      discount: null,
      discountType: null,
      voucherCode: null,
    }

    data.auth.updateUser(userData).then(() => {
      setTimeout(function () {
        onUpdate()
        setLoading('')
      }, 1000)
    })
  }

  if (!currencySign || pageText.length === 0) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">{pageText[10]}</span>
        </div>
      </div>
    )
  }
  return (
    <div className="container">
      <div className="row justify-content-center">
        <ContainerBox>
          {data.auth.user.membershipFeeStatus === 'completed' ? (
            <>
              <Title
                center
                size="29px"
                sizemd="29px"
                sizesm="24px"
                margin="0 0 20px 0"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[1]}`,
                }}
              ></Title>
              <Subtitle
                center
                weight="400"
                size="20px"
                margin="20px 0 20px 0"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[12]} ${currencySign}${(Math.round(data.auth.user.membershipFee * 100) / 100).toFixed(2)}`,
                }}
              />
            </>
          ) : (
            <div>
              <CenterSmallMargin>
                <img
                  src="/images/icons/licensePaypal.svg"
                  alt=""
                  className="img-secured-by-stripe-mini-app3"
                />
                <img
                  src="/images/icons/licensePaypal-mobile2.svg"
                  alt=""
                  className="img-secured-by-stripe-mini-mobile-app3"
                />
              </CenterSmallMargin>

              <PriceChoiceBox>
                <PriceChoiceTitle
                  center
                  size="27px"
                  sizemd="27px"
                  sizesm="24px"
                  margin="0"
                  dangerouslySetInnerHTML={{
                    __html: `${pageText[21]}`,
                  }}
                />

                <PriceChoiceSubtitle
                  center
                  size="28px"
                  margin="0 0 10px 1%"
                  dangerouslySetInnerHTML={{
                    __html: `${pageText[22]}`,
                  }}
                />

                <PriceChoiceSubtitle
                  center
                  size="28px"
                  margin="0 0 10px 1%"
                  dangerouslySetInnerHTML={{
                    __html: `${pageText[23]}`,
                  }}
                />

                <FlexRowPrice>
                  <PriceBox>
                    <PriceBoxHeader>
                      {' '}
                      <PriceHeaderSubtitle
                        center
                        size="18px"
                        margin="0"
                        dangerouslySetInnerHTML={{
                          __html: `${pageText[24]}`,
                        }}
                      />
                    </PriceBoxHeader>
                    <PriceBoxPrice>
                      <PriceContainer>
                        <CurrencySubtitle
                          center
                          size="16px"
                          margin="0"
                          dangerouslySetInnerHTML={{
                            __html: `${currencySign}`,
                          }}
                        />
                        <PriceSubtitle
                          center
                          size="50px"
                          margin="0"
                          dangerouslySetInnerHTML={{
                            __html: `19.90`,
                          }}
                        />
                        <PriceDurationSubtitle
                          center
                          size="13px"
                          margin="0"
                          dangerouslySetInnerHTML={{
                            __html: `${pageText[25]}`,
                          }}
                        />
                      </PriceContainer>
                    </PriceBoxPrice>
                    <PriceBoxInfo>
                      {' '}
                      <PriceInfoSubtitle
                        center
                        size="14px"
                        margin="0"
                        dangerouslySetInnerHTML={{
                          __html: `<b>${currencySign}6.63</b> ${pageText[26]}`,
                        }}
                      />
                      {loading === 'quarterly' ? (
                        <ChoiceLoadingButton
                          type="submit"
                          padding="10px 60px"
                          margin="0"
                          fontsize="16px"
                          onClick={(e) => {
                            handleSetPriceButton(e, 19.9, 'quarterly')
                          }}
                        >
                          {pageText[30]}
                        </ChoiceLoadingButton>
                      ) : (
                        <ChoiceButton
                          type="submit"
                          padding="10px 60px"
                          margin="0"
                          fontsize="16px"
                          onClick={(e) => {
                            handleSetPriceButton(e, 19.9, 'quarterly')
                          }}
                        >
                          {pageText[30]}
                        </ChoiceButton>
                      )}
                    </PriceBoxInfo>
                  </PriceBox>
                  <PriceBox>
                    <PriceBoxHeader>
                      {' '}
                      <PriceHeaderSubtitle
                        center
                        size="18px"
                        margin="0"
                        dangerouslySetInnerHTML={{
                          __html: `${pageText[27]}`,
                        }}
                      />
                    </PriceBoxHeader>
                    <PriceBoxPrice>
                      <PriceContainer>
                        <CurrencySubtitle
                          center
                          size="16px"
                          margin="0"
                          dangerouslySetInnerHTML={{
                            __html: `${currencySign}`,
                          }}
                        />
                        <PriceSubtitle
                          center
                          size="50px"
                          sizeSm="50px"
                          margin="0"
                          dangerouslySetInnerHTML={{
                            __html: `29.90`,
                          }}
                        />
                        <PriceDurationSubtitle
                          center
                          size="13px"
                          margin="0"
                          dangerouslySetInnerHTML={{
                            __html: `${pageText[28]}`,
                          }}
                        />
                      </PriceContainer>
                    </PriceBoxPrice>
                    <PriceBoxInfo>
                      {' '}
                      <PriceInfoSubtitle
                        center
                        size="14px"
                        margin="0"
                        dangerouslySetInnerHTML={{
                          __html: `<b>${currencySign}4.98</b> ${pageText[29]}`,
                        }}
                      />
                      {loading === 'semi-annual' ? (
                        <ChoiceLoadingButton
                          type="submit"
                          padding="10px 60px"
                          margin="0"
                          fontsize="16px"
                          onClick={(e) => {
                            handleSetPriceButton(e, 29.9, 'semi-annual')
                          }}
                        >
                          {pageText[30]}
                        </ChoiceLoadingButton>
                      ) : (
                        <ChoiceButton
                          type="submit"
                          padding="10px 60px"
                          margin="0"
                          fontsize="16px"
                          onClick={(e) => {
                            handleSetPriceButton(e, 29.9, 'semi-annual')
                          }}
                        >
                          {pageText[30]}
                        </ChoiceButton>
                      )}
                    </PriceBoxInfo>
                  </PriceBox>
                  <PriceBoxHeaderBadgeContainer>
                    <PriceBoxHeaderBadge>
                      {' '}
                      <PriceHeaderBadgeSubtitle
                        center
                        size="28px"
                        margin="0"
                        dangerouslySetInnerHTML={{
                          __html: `${pageText[31]}`,
                        }}
                      />
                    </PriceBoxHeaderBadge>
                    <PriceBox shadow>
                      <PriceBoxHeader>
                        {' '}
                        <PriceHeaderSubtitle
                          center
                          size="18px"
                          margin="0"
                          dangerouslySetInnerHTML={{
                            __html: `${pageText[32]}`,
                          }}
                        />
                      </PriceBoxHeader>
                      <PriceBoxPrice>
                        <PriceContainer>
                          <CurrencySubtitle
                            center
                            size="16px"
                            margin="0"
                            dangerouslySetInnerHTML={{
                              __html: `${currencySign}`,
                            }}
                          />
                          <PriceSubtitle
                            center
                            size="50px"
                            margin="0"
                            dangerouslySetInnerHTML={{
                              __html: `47.90`,
                            }}
                          />
                          <PriceDurationSubtitle
                            center
                            size="13px"
                            margin="0"
                            dangerouslySetInnerHTML={{
                              __html: `${pageText[33]}`,
                            }}
                          />
                        </PriceContainer>
                      </PriceBoxPrice>
                      <PriceBoxInfo>
                        {' '}
                        <PriceInfoSubtitle
                          center
                          size="14px"
                          margin="0"
                          dangerouslySetInnerHTML={{
                            __html: `<b>${currencySign}3.99</b> ${pageText[34]}`,
                          }}
                        />
                        {loading === 'annual' ? (
                          <ChoiceLoadingButton
                            type="submit"
                            padding="10px 60px"
                            margin="0"
                            fontsize="16px"
                            onClick={(e) => {
                              handleSetPriceButton(e, 47.9, 'annual')
                            }}
                          >
                            {pageText[30]}
                          </ChoiceLoadingButton>
                        ) : (
                          <ChoiceButton
                            type="submit"
                            padding="10px 60px"
                            margin="0"
                            fontsize="16px"
                            onClick={(e) => {
                              handleSetPriceButton(e, 47.9, 'annual')
                            }}
                          >
                            {pageText[30]}
                          </ChoiceButton>
                        )}
                      </PriceBoxInfo>
                    </PriceBox>
                  </PriceBoxHeaderBadgeContainer>
                </FlexRowPrice>
              </PriceChoiceBox>

              {/* What's Included */}
              <WhatsIncludedWrapper>
                <WhatsIncludedPanel />
              </WhatsIncludedWrapper>

              {/* Testimonials */}
              <TestimonialsWrapper>
                <TestimonialsPanel showintro={true} numbertoshow={10} />
              </TestimonialsWrapper>

              {/* Trust & Security / ID */}
              <WhyDoWeChargeAFee pageText={pageText} pageText2={pageText2} />

              <Center>
                <img
                  src="/images/icons/licensePaypal.svg"
                  alt=""
                  className="img-secured-by-stripe-mini-app2"
                />
                <img
                  src="/images/icons/licensePaypal-mobile.svg"
                  alt=""
                  className="img-secured-by-stripe-mini-mobile-app2"
                />
              </Center>
            </div>
          )}
        </ContainerBox>
      </div>
    </div>
  )
}

export default withRouter(withAuth(ChooseSubscription))
